"use client";
import { formatDate, formatDateTime } from "@/lib/utils";

import { Breadcrumb } from "@ama-pt/agora-design-system";
import Image from "@/components/atoms/image";
import NotFound from "@/app/[locale]/not-found";
import { useLocale, useTranslations } from "next-intl";
import { NewsData } from "@/services/new/types";
import { RichText } from "../RichText/RichText";
import Heading from "@/components/molecules/Heading";
interface PublicationPageClientProps {
  postData: NewsData;
  content: any;
}

export function PostPageClient({
  postData,
}: PublicationPageClientProps) {
  const t = useTranslations();
  const locale = useLocale();
  const data = postData.items[0];
  if (!data) {
    return NotFound();
  }

  return (
    <div className="">
      <div className="py-24">
        <div className="container mx-auto">
          <Breadcrumb
            items={[
              {
                label: t("Breadcrumb.homePage"),
                url: "/",
              },
              {
                label: t("Breadcrumb.noticias"),
                url: locale === "pt" ? "/noticias-e-artigos" : "/news-and-articles",
              },
              {
                label: data.title,
                url: "",
              },
            ]}
          />
        </div>
        <div className="container mx-auto md:mt-64 mt-32">
          <div
            className={`text-xl-regular md:text-2xl-regular md:max-w-[90%] xl:text-3xl-regular bg-no-repeat bg-[length:100%_50%] bg-top`}
            style={{
              display: "inline",
              boxDecorationBreak: "clone",
              WebkitBoxDecorationBreak: "clone",
              backgroundImage: `linear-gradient(to bottom,#F1F6F3,#F1F6F3)`,
            }}
          >
            <Heading title={data?.richtitle || data?.title} />
          </div>
          {data?.publishedAt && (
            <time
              className="block mt-16 text-m-regular text-neutral-900"
              dateTime={formatDateTime(data?.publishedAt)}
            >
              {formatDate(data.publishedAt)}
            </time>
          )}
        </div>
        <div className="container mx-auto py-64 px-0 md:px-64 xl:px-128">
          <div className="text-m-regular text-neutral-900 max-w-[80ch] mx-auto">
            {data?.featuredImage?.url && (
              <div className="float-left w-2/3 pr-32 pb-16">
                <Image
                  src={data.featuredImage.url}
                  alt={data.featuredImage.alt || data.title}
                  width={0}
                  height={0}
                  sizes="50vw"
                  className="w-full rounded"
                  priority
                />
              </div>
            )}
            <p className="text-m-bold text-primary-500">
              {data?.categories?.map((category: any) => category.name).join(", ")}
            </p>
            {data?.contentText && (
              <RichText content={data.contentText}
                className="text-m-regular !max-w-[80ch] text-neutral-900 pb-8 prose prose-ul:my-0 marker:text-neutral-900"
              />
            )}
            {data?.updatedAt && (
            <time
              className="block mt-16 text-m-regular text-neutral-900"
              dateTime={formatDateTime(data?.updatedAt)}
            >
              {t("Carlist.updatedAt")}: {formatDate(data.updatedAt)}
            </time>
          )}
            <div className="clear-both" />
          </div>
        </div>
      </div>
    </div>
  );
}
